import DashboardPageContainer from "./dashboard-page-container"

export default DashboardPageContainer
